// extracted by mini-css-extract-plugin
export default {"container":"MatchEvents_container__6La44","name":"MatchEvents_name__A-XAl","time":"MatchEvents_time__ROSy6"};